import React from "react";
import './index.css';
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Input from "../../../Components/Control/Input";
import Select from "../../../Components/Control/Select";
import {connect} from "react-redux";
import Resource from "../../../Resource";
import PropTypes from 'prop-types';
import {Tool} from "../../../App";
import Notif from "../../../Components/Notif";
import Date from "../../../Components/Control/Date";
import Patient from "../../../Server/Patient";
import moment from "jalali-moment";
import MyComponent from '../../../Components/MyComponent';

class ModalPatient extends MyComponent {
    constructor(props) {
        super(props);
        props.refer.current = this;


        this.state = {
            title: {
                UPDATE: 'ویرایش بیمار',
                VIEW: 'اطلاعات بیمار'
            },
            fields: {},
            error: false,
            provinces: props.base?.provinceCities?.map(item => {
                return {
                    id: item.provinceId, text: item.provinceName, cities: item?.cities?.map(item => {
                        return {id: item.cityId, text: item.cityName};
                    }) || []
                };
            })
        };

        this.ref = {
            modal: React.createRef(),
            update: React.createRef(),
            close: React.createRef(),
            genderId: React.createRef(),
            patientBloodGroupId: React.createRef(),
            birthDate: React.createRef(),
            nationalCode: React.createRef(),
            fatherName: React.createRef(),
            cityId: React.createRef(),
            provinceId: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        genderId: x => Boolean(x && x[0]?.id) || 'جنسیت انتخاب نشده است.',
        birthDate: x => x.format() !== 'Invalid date' || 'تاریخ تولد وارد نشده است.',
        nationalCode: x => Boolean(x) || 'کدملی وارد نشده است.',
        fatherName: x => true,
        patientBloodGroupId: x => Boolean(x && x[0]?.id) || 'گروه خونی انتخاب نشده است.',
        cityId: x => Boolean(x && x[0]?.id) || 'شهر انتخاب نشده است.',
        provinceId: x => Boolean(x && x[0]?.id) || 'استان انتخاب نشده است.'
    };

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.fields !== nextState.fields;
    }

    render() {
        const {state, props} = this;
        let readOnly = state.action === ModalAction.VIEW;
        const genders = [{id: '', text: '...'}, {id: 1, text: 'مرد'}, {id: 2, text: 'زن'}];
        const cities = state.fields?.provinceId && state.fields?.provinceId[0]?.cities ? [{id: '', text: '...'}, ...state.fields?.provinceId[0]?.cities] : [{id: '', text: '...'}];
        const bloodGroups = [
            {id: '', text: '...'},
            ...props.base.bloodGroups.map(item => ({id: item.id, text: item.name}))
        ];

        return <Modal ref={this.ref.modal}
                      name={'ModalPatient'}
                      size={'medium'}
                      title={state.title[state.action]}
                      error={state.error}>
            <ModalContent>
                <div className={'dis-f'}>
                    <Input value={state.fields?.fileCode} className={'pad-4 fb-7 fb-3x-10 fb-2x-20'} label={'شماره پرونده'} readOnly={true}/>
                    <Input ref={this.ref.nationalCode} value={state.fields?.nationalCode} className={'pad-4 fb-7 fb-3x-10 fb-2x-20'} label={'کد ملی'} readOnly={readOnly} validation={this.validations.nationalCode} onChange={this.setField.bind(this, 'nationalCode')}/>
                    <Input ref={this.ref.fatherName} value={state.fields?.fatherName} className={'pad-4 fb-6 fb-3x-10 fb-2x-20'} label={'نام پدر'} readOnly={readOnly} validation={this.validations.fatherName} onChange={this.setField.bind(this, 'fatherName')}/>
                    <Input value={state.fields?.firstName} className={'pad-4 fb-6 fb-3x-10 fb-2x-20'} label={'نام'} readOnly={true}/>
                    <Input value={state.fields?.lastName} className={'pad-4 fb-7 fb-3x-10 fb-2x-20'} label={'نام خانوادگی'} readOnly={true}/>
                    <Select ref={this.ref.patientBloodGroupId} value={state.fields?.patientBloodGroupId} options={bloodGroups} className={'pad-4 fb-7 fb-3x-10 fb-2x-20'} label={'گروه خونی بیمار'} readOnly={readOnly} validation={this.validations.patientBloodGroupId} onChange={this.setField.bind(this, 'patientBloodGroupId')}/>
                    <Date ref={this.ref.birthDate} value={state.fields?.birthDate} className={'pad-4 fb-10 fb-2x-20'} label={'تاریخ تولد'} readOnly={readOnly} validation={this.validations.birthDate} onChange={this.setField.bind(this, 'birthDate')}/>
                    <Select ref={this.ref.genderId} value={state.fields?.genderId} className={'pad-4 fb-10 fb-2x-20'} label={'جنسیت'} readOnly={readOnly} validation={this.validations.genderId} options={genders} onChange={this.setField.bind(this, 'genderId')}/>
                    <Select ref={this.ref.provinceId} value={state.fields?.provinceId} className={'pad-4 fb-10 fb-2x-20'} label={'استان'} readOnly={readOnly} validation={this.validations.provinceId} options={state.provinces} onChange={this.setField.bind(this, 'provinceId')}/>
                    <Select ref={this.ref.cityId} value={state.fields?.cityId} className={'pad-4 fb-10 fb-2x-20'} label={'شهر'} readOnly={readOnly} validation={this.validations.cityId} options={cities} onChange={this.setField.bind(this, 'cityId')}/>
                </div>
            </ModalContent>
            <ModalControls>
                {state.action === ModalAction.UPDATE && <Button refer={this.ref.update} className={'mar-4'} theme={'yellow'} onClick={this.updateClickHandler.bind(this)}>ویرایش بیمار</Button>}
                <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
            </ModalControls>
        </Modal>;
    }

    close(success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    fieldWillUpdate(keys, value, currentFields, nextFields) {
        switch (keys[0]) {
            case 'provinceId':
                delete nextFields['cityId'];
                break;
            default:
        }
    }

    open(data, action) {
        const {state} = this;
        const province = state.provinces.find(item => item.id === data.provinceId);

        this.setState({
            data,
            action,
            fields: {
                fileCodeId: data?.fileCodeId,
                fileCode: data?.fileCode,
                nationalCode: data?.nationalCode,
                firstName: data?.firstName,
                lastName: data?.lastName,
                fatherName: data?.fatherName,
                birthDate: data?.birthDate ? moment(data?.birthDate, 'jYYYY-jMM-jDD') : null,
                genderId: [{id: data?.genderId}],
                cityId: [{id: data?.cityId}],
                patientBloodGroupId: [{id: data?.bloodGroupId || ''}],
                provinceId: [province]
            },
            error: null
        });

        return this.ref.modal.current.open();
    }

    updateClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            ref.update.current.loading();
            this.setState({error: null});

            Patient.updatePatient({
                fileCodeId: state.fields?.fileCodeId,
                genderId: state.fields?.genderId[0]?.id,
                birthDate: state.fields?.birthDate.format('jYYYY-jMM-jDD'),
                nationalCode: state.fields?.nationalCode,
                fatherName: state.fields?.fatherName,
                cityId: state.fields?.cityId[0]?.id,
                patientBloodGroupId: state.fields?.patientBloodGroupId[0]?.id,
                provinceId: state.fields?.provinceId[0]?.id
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.UPDATE_SUCCESSFUL).show();

                ref.update.current.loading(false);
                this.close(true);
            }).catch(message => {
                ref.update.current.loading(false);

                this.setState({error: message});
            });
        }
    }

    validate() {
        const validate = Tool.validate(
            this.ref.nationalCode,
            this.ref.birthDate,
            this.ref.genderId,
            this.ref.provinceId,
            this.ref.patientBloodGroupId,
            this.ref.cityId);

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base
    };
};

export default connect(mapStateToProps)(ModalPatient);